import RestClient from "RestClient";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const restClient = new RestClient();

export const emailValidation = async (payload) => {
  const result = await restClient.get(
    `${BASE_URL}/users/validateEmail`,
    payload
  );
  return result;
};

export const doLogin = async (payload) => {
  const result = await restClient.post(
    `${BASE_URL}/users/authenticate`,
    payload
  );
  const { data, status } = result;
  if (status) {
    return data;
  } else {
    return result;
  }
};

/**
 * SECURITY: CWE-645 - Missing Brute Force Protection - Mitigation
 * 
 * Fetches a CAPTCHA challenge from the server.
 * Used when CAPTCHA is required after multiple failed login attempts.
 */
export const getCaptcha = async () => {
  const result = await restClient.get(`${BASE_URL}/users/captcha`);
  const { data, status } = result;
  if (status) {
    return data;
  } else {
    return result;
  }
};

/**
 * SECURITY: CWE-645 - Missing Brute Force Protection - Mitigation
 * 
 * Checks if CAPTCHA is required for a given email address.
 * Allows the frontend to proactively show CAPTCHA.
 */
export const checkCaptchaRequired = async (email) => {
  const result = await restClient.get(
    `${BASE_URL}/users/checkCaptchaRequired`,
    { email }
  );
  const { data, status } = result;
  if (status) {
    return data;
  } else {
    return result;
  }
};

export const updatePassword = async (payload) => {
  const result = await restClient.post(
    `${BASE_URL}/users/resetpassword`,
    payload
  );
  const { data, status } = result;
  if (status) {
    return data;
  } else {
    return result;
  }
};

export const doRegister = async (payload) => {
  const result = await restClient.post(`${BASE_URL}/users/register`, payload);
  return result;
};

export const checkIfLoggedIn = () => {
  const result = sessionStorage.getItem("userInfo");
  if (result) {
    return result;
  }
  return false;
};

/**
 * Logout function
 * SECURITY: Calls backend to invalidate token and revoke refresh tokens
 * Then clears client-side session storage
 */
export const doLogout = async () => {
  try {
    // SECURITY: Call backend logout endpoint to invalidate token server-side
    // This prevents replay attacks using logged-out tokens
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
    if (userInfo?.token) {
      try {
        await restClient.post(`${BASE_URL}/users/logout`, {});
      } catch (error) {
        // Even if backend call fails, clear client-side storage
        // This ensures logout works even if backend is unreachable
        console.error("Logout API call failed, clearing local storage:", error);
      }
    }
  } catch (error) {
    // Ignore errors - always clear session storage
    console.error("Error during logout:", error);
  } finally {
    // SECURITY: Always clear session storage regardless of API call result
    sessionStorage.clear();
  }
  return true;
};

export const requestResetPassword = async (payload) => {
  const result = await restClient.post(
    `${BASE_URL}/users/requestPasswordReset`,
    payload
  );
  return result;
};

export const doResetPassword = async (payload) => {
  const result = await restClient.post(
    `${BASE_URL}/users/doPasswordReset`,
    payload
  );
  return result;
};

export const fetchCategories = async () => {
  const result = await restClient.get(`${BASE_URL}/categories`);
  return result;
};

export const doPayment = async (payload) => {
  const result = await restClient.post(`${BASE_URL}/payments`, payload);
  return result;
};

export const verifyPayment = async (payload) => {
  const result = await restClient.post(`${BASE_URL}/payments/verify`, payload);
  return result;
};

export const insertSettings = async (payload) => {
  const result = await restClient.post(`${BASE_URL}/settings`, payload);
  return result;
};

/**
 * SECURITY: CWE-840 - Business Logic Errors - Mitigation
 * 
 * Validates workflow step access server-side.
 * Prevents users from accessing steps out of sequence.
 */
export const validateWorkflowStep = async (stepIndex) => {
  const result = await restClient.get(
    `${BASE_URL}/users/workflow/validateStep`,
    { stepIndex }
  );
  const { data, status } = result;
  if (status) {
    return data;
  } else {
    return result;
  }
};

/**
 * SECURITY: CWE-840 - Business Logic Errors - Mitigation
 * 
 * Gets workflow step status for the current user.
 */
export const getWorkflowStepStatus = async () => {
  const result = await restClient.get(`${BASE_URL}/users/workflow/stepStatus`);
  const { data, status } = result;
  if (status) {
    return data;
  } else {
    return result;
  }
};

/**
 * SECURITY: CWE-840 - Business Logic Errors - Mitigation
 * 
 * Validates a password reset token before showing the reset form.
 */
export const validateResetToken = async (email, token) => {
  const result = await restClient.get(
    `${BASE_URL}/users/validateResetToken`,
    { email, token }
  );
  const { data, status } = result;
  if (status) {
    return data;
  } else {
    return result;
  }
};
